import Enumerable from "linq";
import {
  FixedPhraseRootReference,
  FixedPhraseReference,
} from "../../../../domain/document";
import {
  Directory
} from "../../../../domain/drawing";

export class FixedPhraseTranslator {
  toFixedPhraseTree(tableId: string, templateId: string, data: any[]): FixedPhraseRootReference {
    return new FixedPhraseRootReference(
      tableId,
      templateId,
      this.toFixedPhraseDirectories(data)
    );
  }

  private toFixedPhraseDirectories(folders: any[]): Directory<number, FixedPhraseReference>[] {
    return Enumerable.from(folders)
      .select((f, i) => this.toFixedPhraseDirectory(f, i))
      .toArray();
  }

  private toFixedPhraseDirectory(folder: any, index: number): Directory<number, FixedPhraseReference> {
    return new Directory(
      index,
      folder.source.name,
      this.toFixedPhraseDirectories(
        Enumerable.from(folder.children as any[])
          .where(f => f.source instanceof Directory)
          .toArray()),
      this.toFixedPhrases(
          Enumerable.from(folder.children as any[])
          .where(f => f.source instanceof FixedPhraseReference)
          .toArray())
    );
  }

  private toFixedPhrases(phrases: any[]): FixedPhraseReference[] {
    return Enumerable.from(phrases)
      .select(p => this.toFixedPhrase(p))
      .toArray();
  }

  private toFixedPhrase(phrase: any): FixedPhraseReference {
    return new FixedPhraseReference(
      phrase.source.name,
      phrase.source.text
    );
  }
}
